import { useState } from 'react';

import { useMutation } from '@tanstack/react-query';
import { openNotification } from 'apps/web/builder/slice/notification.slice';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';

import { forgotPassword } from '../api';

export default function useRegister() {
  const dispatch = useDispatch();
  const router = useRouter();

  const [user, setUser] = useState({
    email: '',
  });

  const handleChangeValue = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;

    setUser({ ...user, [name]: value });
  };

  const { mutate } = useMutation({
    mutationKey: ['forgotPassword'],
    mutationFn: async () => {
      const payload = {
        email: user.email,
      };

      const response = await forgotPassword(payload);
      return response;
    },
    onSuccess(response) {
      if (response.id) {
        dispatch(
          openNotification({
            type: 'success',
            title: 'Success send forgot password email',
          })
        );
        setTimeout(() => {
          router.push('/');
        }, 2000);
      }

      response?.statusCode === 400 &&
        dispatch(openNotification({ type: 'error', title: response.message }));

      response?.code === 100 &&
        dispatch(
          openNotification({
            type: 'error',
            title: response.error_user_title ?? response.message,
            description: response.error_user_msg ?? '',
          })
        );
    },
  });

  return { user, setUser, handleChangeValue, forgotPassword: mutate };
}
